import React, {useEffect} from "react"
import LowHeader from "./LowHeaderContainer"
import {observer} from "mobx-react-lite"
import {UseStores} from "../../hooks/UseStores"
import {defaultGeo, URLPATHS} from "../../utils/utils"
import MapNavigation from "../../components/MapNavigation"

const Brands = ({children, handleGeoUpdate}) => {
  const {disStore, locGroupStore, navStore, gtMapStore, paginationStore} = UseStores()
  const currentPage = window.location.pathname

  useEffect(() => {
    navStore.setCurrentPage(URLPATHS.DISCOVERYBRANDS)
    if (navStore.previousPage === URLPATHS.LOCATIONGROUPS) {
      locGroupStore.setLocGeoTime({geo: defaultGeo})
    }
    paginationStore.resetDefault()
  }, [])

  useEffect(() => {
    if (disStore.tableStates.selected !== null) {
      updateGTMapStore(disStore.geoTimeObj.timePeriod)
    }
  }, [JSON.stringify(disStore.mapGeoObj)])

  const updateGTMapStore = (visitDuration) => {
    disStore.updateMapGeoRequest() //update requestIds before updating map component
    const mapParams = {
      geo: disStore.geoTimeObj.geo,
      categoryId: disStore.sicCode,
      brandId: disStore.brandId,
      visitDuration: null,
      mapGeos: disStore.mapGeos,
      showLoader: disStore.showLoader,
      locationGroupId: null,
      mapPadding: {left: 500},
    }
    gtMapStore.setMapObj(mapParams)
  }
  return (
    <div className="brands-LG-container">
      <LowHeader />
      <MapNavigation geoObj={disStore.geoTimeObj.geo} handleUpdate={handleGeoUpdate} />
      <div
        className="brandsPage"
        id={currentPage.includes("locations") ? "locations-brandsPage" : ""}
      >
        <div className="brandsLeft">{children}</div>
      </div>
    </div>
  )
}
export default observer(Brands)
